<script>
    import axios from 'axios';

    export default {
        props: {
            id: String,
        },
        methods: {
            close() {
                this.$store.commit('closeModal');
            },
            async activate() {
                console.log(this.id);
                await axios.put(`/api/organisation/employees/${this.id}/active`, { Active: true } );
                this.close();
                location.reload();
            }
        }
    };
</script>

<template>
    <header class="modal-card-head">
        <p class="modal-card-title">{{ $store.getters.getUserManagementText('usermanagementModalTitleActivate') }}</p>
        <button class="delete" aria-label="close" @click="close"></button>
    </header>
    <section class="modal-card-body">{{ $store.getters.getUserManagementText('usermanagementModalContentActivate') }}</section>
    <footer class="modal-card-foot is-justify-content-end">
        <button class="button is-primary is-outlined" @click="close">{{ $store.getters.getUserManagementText('usermanagementModalButtonCancel') }}</button>
        <button class="button is-success" @click="activate">{{ $store.getters.getUserManagementText('usermanagementModalButtonActivate') }}</button>
    </footer>
</template>
